import { Component } from '@angular/core';
import { MAPSPersonVolunteerActivityEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Person Volunteer Activities') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-mapspersonvolunteeractivity-form',
    templateUrl: './mapspersonvolunteeractivity.form.component.html'
})
export class MAPSPersonVolunteerActivityFormComponent extends BaseFormComponent {
    public record!: MAPSPersonVolunteerActivityEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

